import { BookingTransactionListDto } from '@/features/dashboard/bookings/types/BookingTransactionListDto.ts';
import { BillPaymentDto } from '@/features/dashboard/bookingChanges/types/dto/BillPaymentDto.ts';

export const bookingTransactionMapper = {
  /**
   * Kwotą wpłaty jest **alokacja na tę rezerwację** (`amount`), a nie kwota
   * całego przelewu (`totalValue`): jedna transakcja bywa rozpisana na kilka
   * rezerwacji.
   */
  toBillPayment(dto: BookingTransactionListDto): BillPaymentDto {
    return {
      id: dto.id,
      paidAt: dto.transactionDate,
      amount: dto.amount,
      totalValue: dto.totalValue,
      tags: dto.tags ?? [],
      reference: dto.description,
      method: dto.paymentMethod,
    };
  },
};
